import {TableColumnStorageConfig} from "../types";

export type TableColumnStorageKey =
    | 'assetList_columnConfig'
    | 'systemList_columnConfig'
    | 'eventList_columnConfig';

export const saveTableColumnConfig = (storageKey: TableColumnStorageKey, config: TableColumnStorageConfig) => {
    localStorage.setItem(storageKey, JSON.stringify(config));
};

export const loadTableColumnConfig = (storageKey: TableColumnStorageKey): TableColumnStorageConfig | null => {
    try {
        const raw = localStorage.getItem(storageKey);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

export const clearTableColumnConfig = (storageKey: TableColumnStorageKey) => {
    localStorage.removeItem(storageKey);
};
